import { get } from "@/shared/api"
import { API_ENDPOINTS } from "@/shared/api/endpoints"

import type { BudgetItemCode } from "../interfaces/budget-item-code"

export const budgetItemCodeService = {
  index: async (): Promise<BudgetItemCode[]> => {
    const response = await get<BudgetItemCode[]>(`${API_ENDPOINTS.BUDGET_ITEMS}/codes`)
    return Array.isArray(response.data) ? response.data : []
  },
}
